<div class="mu">
  <div class="mu-fej">
    <h2>Ügyfelek</h2>
    <span class="mu-mod" *ngIf="mod" [class.onallo]="onallo" [title]="onallo ? 'Saját ügyfélkör, a Könyvelés nélkül' : 'Az ügyfelek a Könyvelésből jönnek'">
      {{ onallo ? 'önálló ügyfélkör' : 'kapcsolt: a Könyvelés ügyfelei' }}</span>
    <span class="mu-ter"></span>
    <button type="button" class="mu-gomb" *ngIf="onallo" (click)="uj()">+ Új ügyfél</button>
  </div>

  <div class="mu-szuro">
    <input type="search" [(ngModel)]="kereso" placeholder="Keresés: név, adószám, település…">
    <label class="mu-jel"><input type="checkbox" [(ngModel)]="csakAktiv"> Csak aktív</label>
    <span class="halvany">{{ szurt.length }} ügyfél</span>
    <span class="mu-ter"></span>
    <div class="mu-nezet">
      <button type="button" [class.aktiv]="nezet === 'csempe'" (click)="nezetValt('csempe')" title="Csempék">▦</button>
      <button type="button" [class.aktiv]="nezet === 'lista'" (click)="nezetValt('lista')" title="Lista">☰</button>
    </div>
  </div>

  <div class="mu-hiba" *ngIf="hiba">{{ hiba }}</div>
  <div class="halvany mu-ures" *ngIf="!betolt && !hiba && !szurt.length">
    <ng-container *ngIf="onallo">Még nincs ügyfél. Vegyél fel egyet az <b>Új ügyfél</b> gombbal.</ng-container>
    <ng-container *ngIf="!onallo">Nincs elérhető ügyfél. Kapcsolt módban az ügyfeleket a Könyvelésben kell felvenni (ügyfélként a könyvelőiroda adhat hozzáférést).</ng-container>
  </div>

  <!-- CSEMPÉK -->
  <div class="mu-racs" *ngIf="nezet === 'csempe'">
    <div class="mu-csempe" *ngFor="let u of szurt" [class.aktiv]="u.id === aktivId" [class.inaktiv]="+u.inaktiv" (click)="valaszt(u)" [title]="'Megnyitás: ' + u.nev">
      <div class="mu-cs-fej">
        <span class="mu-azon" *ngIf="u.azonosito">{{ u.azonosito }}</span>
        <span class="mu-szerep" *ngIf="modul?.szerepes && u.szerep" [attr.data-sz]="u.szerep">{{ u.szerep === 'ugyfel' ? 'saját cég' : 'könyvelő – olvas' }}</span>
        <span class="mu-ter"></span>
        <button type="button" class="mu-szerk" *ngIf="onallo" (click)="szerkeszt(u, $event)" title="Adatok">✎</button>
      </div>
      <div class="mu-nev">{{ u.nev }}</div>
      <div class="mu-meta" *ngIf="u.adoszam">Adószám: {{ u.adoszam }}</div>
      <div class="mu-meta" *ngIf="u.telepules">{{ cim(u) }}</div>
      <div class="mu-meta" *ngIf="u.eszkoz_db != null">{{ u.eszkoz_db }} aktív eszköz</div>
    </div>
  </div>

  <!-- LISTA -->
  <div class="mu-lista" *ngIf="nezet === 'lista' && szurt.length">
    <table>
      <thead><tr><th>Azonosító</th><th>Név</th><th>Adószám</th><th>Cím</th><th *ngIf="modul?.szerepes">Szerep</th><th *ngIf="alr === 'ESZKOZ'">Eszköz</th><th></th></tr></thead>
      <tbody>
        <tr *ngFor="let u of szurt" [class.aktiv]="u.id === aktivId" [class.inaktiv]="+u.inaktiv" (click)="valaszt(u)">
          <td class="mu-azon">{{ u.azonosito }}</td><td class="mu-nev">{{ u.nev }}</td><td>{{ u.adoszam }}</td><td>{{ cim(u) }}</td>
          <td *ngIf="modul?.szerepes"><span class="mu-szerep" *ngIf="u.szerep" [attr.data-sz]="u.szerep">{{ u.szerep === 'ugyfel' ? 'saját cég' : 'könyvelő – olvas' }}</span></td>
          <td *ngIf="alr === 'ESZKOZ'">{{ u.eszkoz_db }}</td>
          <td><button type="button" class="mu-szerk" *ngIf="onallo" (click)="szerkeszt(u, $event)" title="Adatok">✎</button></td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- ÜGYFÉLKÖR (önálló / kapcsolt) -->
  <div class="mu-beall">
    <button type="button" class="mu-link" (click)="beallitasNyitva = !beallitasNyitva">{{ beallitasNyitva ? '▾' : '▸' }} Ügyfélkör beállítása (önálló / kapcsolt)</button>
    <app-ugyfelkor-beallitas *ngIf="beallitasNyitva" [alrendszer]="alr" (valtozott)="modValtozott()"></app-ugyfelkor-beallitas>
  </div>
</div>

<!-- Saját ügyfél felvétele / szerkesztése (önálló mód) -->
<div class="mu-fatyol" *ngIf="szerk" (click)="szerk = null">
  <div class="mu-urlap" (click)="$event.stopPropagation()">
    <h3>{{ szerk.id ? 'Ügyfél adatai' : 'Új ügyfél' }}</h3>
    <div class="mu-mezok">
      <label class="szeles">Név *<input [(ngModel)]="szerk.nev" autofocus></label>
      <label>Azonosító<input [(ngModel)]="szerk.azonosito" maxlength="20"></label>
      <label>Adószám<input [(ngModel)]="szerk.adoszam" placeholder="12345678-1-12"></label>
      <label>Közösségi adószám<input [(ngModel)]="szerk.koz_adoszam" placeholder="HU12345678"></label>
      <label>Irányítószám<input [(ngModel)]="szerk.irsz"></label>
      <label>Település<input [(ngModel)]="szerk.telepules"></label>
      <label class="szeles">Cím<input [(ngModel)]="szerk.cim"></label>
      <label>E-mail<input [(ngModel)]="szerk.email"></label>
      <label>Telefon<input [(ngModel)]="szerk.telefon"></label>
      <label class="szeles">Bankszámla<input [(ngModel)]="szerk.bankszamla"></label>
      <label class="szeles">Megjegyzés<input [(ngModel)]="szerk.megjegyzes"></label>
      <label class="jel"><input type="checkbox" [(ngModel)]="szerk.afa_alany"> ÁFA-alany</label>
      <label class="jel"><input type="checkbox" [(ngModel)]="szerk.inaktiv"> Inaktív</label>
    </div>
    <div class="mu-hiba" *ngIf="szerkHiba">{{ szerkHiba }}</div>
    <div class="mu-gombok">
      <button type="button" class="mu-link" (click)="szerk = null">Mégse</button>
      <button type="button" class="mu-gomb" (click)="ment()">Mentés</button>
    </div>
  </div>
</div>
